export default function SolidWeakBtn({
  id,
  type,
  onClick,
  ariaLabel,
  children,
  dataRole,
}: {
  id?: string;
  type?: "button" | "submit" | "reset";
  ariaLabel?: string;
  onClick: () => void;
  children: React.ReactNode;
  dataRole?: string;
}) {
  return (
    <button
      type={type}
      id={id}
      onClick={onClick}
      className="bg-her-aaa text-white px-4 py-1 rounded cursor-pointer"
      aria-label={ariaLabel}
      data-role={dataRole}
    >
      {children}
    </button>
  );
}
